import { Component, OnInit, ViewContainerRef, isDevMode } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { IMyDpOptions, IMyInputFieldChanged } from 'mydatepicker';
import 'rxjs/add/operator/map';
import { ReportClass } from '../Classes/ReportClass';
import { ReportService } from '../Services/ReportService';
import { EntityService } from '../Services/EntityService';
import { DISABLED } from '@angular/forms/src/model';
import { flatten } from '@angular/compiler';
import { Organization } from '../Classes/OrganizationClass';
import { OrganizationService } from '../Services/OrganizationService';
import { Observable } from 'rxjs';
import { Headers, Http, Response, RequestOptions } from '@angular/http';


@Component({
  selector: 'Pl-Grouping',
  templateUrl: '../Reports/PLReportGrouping.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css'],
  providers: [ReportService, EntityService]
})
export class PLReportGroupingComponent implements OnInit {
  Mainmodel = new ReportClass();
  _State: string = "";
  _tenatidget: string = "";
  AllState: any[];
  innerWidth: number;
  ParentPage: string = "";
  QueryReportName: string = "";
  QueryPageName: string = "";
  ReportID: number;
  AllAccExecutive: any[];
  _Organization = new Organization();
  loading: boolean = false;
  QueryTenantID: any = [];
  QueryMessage: any = [];
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  SearchdropFirst: any[] = [
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'Pname', Text: 'Org Name' },
    { Value: 'lettercode', Text: 'Org Code' },
    { Value: 'City', Text: 'City' },
    { Value: 'State', Text: 'State' },
    { Value: 'Status', Text: 'Status' }
  ]
  SearchdropSecond: any[] = [
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'Pname', Text: 'Org Name' },
    { Value: 'lettercode', Text: 'Org Code' },
    { Value: 'City', Text: 'City' },
    { Value: 'State', Text: 'State' },
    { Value: 'Status', Text: 'Status' }
  ]
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    height: '20px',
    width: '100%',
    selectionTxtFontSize: '12px',
    inline: false,
    editableDateField: false,
    //markDates: [color: 'green'],
    selectorHeight: '218px',
    selectorWidth: '247px',
    openSelectorOnInputClick: true
   
  };
  private placeholder: string = 'Select a date';

  /*-------Report Show Hide Value-----*/
  ShowOrganization: boolean;
  ShowSubscription: boolean;
  ShowEntity: boolean;
  ShowMonthly: boolean;
  ShowMonthlyMSUb: boolean;
  ShowMonthlyBookingDate: boolean;
  DateRange: boolean;
  BookingDateRange: boolean;
  BussinessAccount: boolean;
  ShowZeroCostSubscription: boolean;
  ShowSubscriptionStatus: boolean;
  InactiveSubscriptions: boolean;
  RadiobtnShowHide: boolean;
  ActiveUsers: boolean;
  ApiBasePath: string = '';
  Mode: string = '';
  ACHTransactionHistoryReport: boolean;
 
  // ApiBasePath: string = '';
  /*-------End-----*/
  constructor(private router: Router, private Activeroute: ActivatedRoute, private _EntityService: EntityService, private _reportService: ReportService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private http: Http) {
    this.innerWidth = 100; this.toastr.setRootViewContainerRef(vcr);
    //if (window.location.hostname == 'localhost') {
    //  this.ApiBasePath = "http://localhost:53294/";
    //}
    //else {
    //  this.ApiBasePath = "http://inn-flowrpt.azurewebsites.net/";
    //}

    
  }
  ngOnInit() {
    this.ChangeHeadeFooterColor();
    this.Mode = 'New';
    this.getalluser();
    this.getallBillingMonth();
    var ReportName = this.Activeroute.snapshot.params['ReportName'];
    var PageName = this.Activeroute.snapshot.params['PageName'];
    this.QueryReportName = JSON.parse(atob(ReportName));
    this.QueryPageName = JSON.parse(atob(PageName));
    this.ReportID = JSON.parse(atob(this.Activeroute.snapshot.params['ReportID']));
    this.RunReportPage();
    this.Mainmodel.AccountExecutive = '-1';
    this.Mainmodel.Type = 'Organization';
    this._Organization.State = "-1";
   // this.FacialRecogChange();
    //this._reportService.GetReportBaseUrl().subscribe(res => {
    //  this.ApiBasePath = res;
    //});

    if (window.location.hostname == 'localhost') {
      this.ApiBasePath = "http://localhost:53294/";
    }
    else {
     // this.ApiBasePath = "http://inn-flowrpt-test.azurewebsites.net/";
      this._reportService.GetReportBaseUrl().subscribe(res => {
        this.ApiBasePath = res;
      });
    }

    
    this._Organization.SearchdropFirst = "TenantID";
    this._Organization.SearchdropSecond = "-1";
    this._Organization.SearchMatchesFirst = "Contains";
    this._Organization.SearchMatchesSecond = "Contains";
  }

  IsRunByBookingdt() {
    console.log(this.Mainmodel.IsRunByBookingDTEnable);
    if (!this.Mainmodel.IsRunByBookingDTEnable) {
      this.Mainmodel.IsRunByBookingDTEnable = false;
        //BookingDateRange = false;
      
    }
  }
  public StateChange(State) {
    this._State = State;
  }
  public TenantIDChange(TenantId) {
    
    if (TenantId != '-1' || TenantId != "" || TenantId != ' ') {
      this._tenatidget = TenantId;
      this.getallBillingMonth();
    }


    
  }
  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }
  public getallBillingMonth() {
     
      this._EntityService.GetBillingMonth(this._tenatidget).subscribe(res => {
        this.AllState = res;
      })
    
    
  }

  public RunReportPage() {
    
    switch (this.ReportID.toString()) {
      case '1':
        this.ShowSubscription = true;
        this.Mainmodel.SubscriptionStatus = "-1"
        this.ShowEntity = false;
        this.ShowMonthlyBookingDate = true;
        this.ShowMonthlyMSUb = false;
        this.InactiveSubscriptions = false;
        this.RadiobtnShowHide = false; 
        this.BussinessAccount = false;
        this.ShowMonthly = true;
        this.ACHTransactionHistoryReport = false;
        break;
      case '3':
        this.ShowSubscription = false;
        this.ShowEntity = true;
        this.ShowMonthly = true;
        this.ShowMonthlyMSUb = false;
        this.ShowMonthlyBookingDate = true;
        this.BussinessAccount = true;
        this.Mainmodel.EntityStatus = "-1";
        this.Mainmodel.EnterPrise = true;
        this.RadiobtnShowHide = false; 
        this.Mainmodel.Hotel = true;
        this.InactiveSubscriptions = false;
        this.Mainmodel.NonHotel = true;
        this.ACHTransactionHistoryReport = false;
        break;
      case '4':
        this.ShowSubscription = false;
        this.ShowEntity = false;
        this.ShowMonthly = false;
        this.ShowMonthlyMSUb = true;
        this.ShowMonthlyBookingDate = true;
        this.BussinessAccount = true;
        this.Mainmodel.EntityStatus = "-1";
        this.Mainmodel.EnterPrise = true;
        this.Mainmodel.Hotel = true;
        this.RadiobtnShowHide = false; 
        this.InactiveSubscriptions = false;
        this.Mainmodel.NonHotel = true;
        this.ACHTransactionHistoryReport = false;

        let date = new Date();

        // Disable/enable dates from 0th forward
        //date.setDate(date.getMonth() + 1);
        date.setMonth(date.getMonth() + 1);

        let copy = this.getCopyOfOptions();
        copy.disableSince = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
        this.myDatePickerOptions = copy;

        break;
      case '5':
        this.ShowSubscription = false;
        this.ShowEntity = false;
        this.ShowMonthly = true;
        this.ShowMonthlyMSUb = false;
        this.ShowMonthlyBookingDate = true;
        this.ShowOrganization = true;
        this.BussinessAccount = false;
        this.Mainmodel.OrganizationStatus = "Active"
        this.Mainmodel.EnterPrise = false;
        this.Mainmodel.Hotel = false;
        this.InactiveSubscriptions = false;
        this.RadiobtnShowHide = false; 
        this.Mainmodel.NonHotel = false;
        this.ACHTransactionHistoryReport = false;
        break;
      case '6':
        this.ShowSubscription = false;
        this.ShowEntity = false;
        this.ShowMonthly = false;
        this.ShowMonthlyMSUb = false;
        this.ShowMonthlyBookingDate = false;
        this.BussinessAccount = false;
        this.Mainmodel.EnterPrise = false;
        this.BookingDateRange = true;
        this.RadiobtnShowHide = true;
        this.Mainmodel.Hotel = false;
        this.Mainmodel.NonHotel = false;
        this.InactiveSubscriptions = false;
        this.DateRange = true;
        this.ACHTransactionHistoryReport = false;
        break;
      case '7':
        this.ShowSubscription = false;
        this.BussinessAccount = false;
        this.ShowEntity = false;
        this.ShowMonthly = false;
        this.ShowMonthlyMSUb = false;
        this.ShowMonthlyBookingDate = false;
        this.Mainmodel.EnterPrise = false;
        this.Mainmodel.Hotel = false;
        this.Mainmodel.NonHotel = false;
        this.DateRange = true;
        this.BookingDateRange = true;
        this.RadiobtnShowHide = true;
        this.ShowEntity = false;
        this.ShowSubscriptionStatus = false;
        this.InactiveSubscriptions = false;
        this.ActiveUsers = false;
        this.ACHTransactionHistoryReport = false;
        break;
      case '8':
        this.ShowSubscription = false;
        this.ShowEntity = false;
        this.ShowSubscriptionStatus = true;
        this.ShowMonthly = false;
        this.ShowMonthlyMSUb = false;
        this.ShowMonthlyBookingDate = false;
        this.BussinessAccount = true;
        this.ShowZeroCostSubscription = false;
        this.Mainmodel.EnterPrise = true;
        this.Mainmodel.Hotel = true;
        this.Mainmodel.NonHotel = true;
        this.DateRange = true;
        this.InactiveSubscriptions = false;
        this.RadiobtnShowHide = false; 
        this.Mainmodel.SubscriptionVersionStatus = "1";
        this.ACHTransactionHistoryReport = false;
        break;
      case '9':
        this.ShowSubscription = false;
        this.BussinessAccount = false;
        this.ShowEntity = false;
        this.ShowMonthly = false;
        this.ShowMonthlyMSUb = false;
        this.ShowMonthlyBookingDate = false;
        this.Mainmodel.EnterPrise = false;
        this.Mainmodel.Hotel = false;
        this.Mainmodel.NonHotel = false;
        this.DateRange = true;
        this.ShowEntity = false;
        this.ShowSubscriptionStatus = false;
        this.RadiobtnShowHide = false; 
        this.ActiveUsers = false;
        this.InactiveSubscriptions = true;
        this.DateRange = false;
        this.ACHTransactionHistoryReport = false;
        break;
      case '10':
        this.ShowSubscription = false;
        this.BussinessAccount = false;
        this.ShowEntity = false;
        this.ShowMonthly = false;
        this.ShowMonthlyMSUb = false;
        this.ShowMonthlyBookingDate = false;
        this.Mainmodel.EnterPrise = false;
        this.Mainmodel.Hotel = false;
        this.Mainmodel.NonHotel = false;
        this.DateRange = false;
        this.ShowEntity = false;
        this.ShowSubscriptionStatus = false;
        this.RadiobtnShowHide = false;
        this.ActiveUsers = false;
        this.InactiveSubscriptions = false;
        this.DateRange = false;
        this.ACHTransactionHistoryReport = true;
        break;
    }
  }

 
  public GetOrgSearchAutocomplete = (SearchStr: any, SearchdropName: any): Observable<any[]> => {
    if (SearchStr) {
      let OrgDetails = { "mQuery": JSON.stringify(SearchdropName), "SearchDropName": JSON.stringify(SearchStr) };
      let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
      let options: RequestOptions = new RequestOptions({ headers: headers, params: OrgDetails });
      return this.http.get('api/Organization/GetOrgSearchAutocomplete', options)
        .map(res => {
          let json = res.json();
          let jsonarray = json;
          return jsonarray;
        })
    }
    else {
      return Observable.of([]);
    }
  }
  /*-------Functions for Run Report by ReportID-----*/
  public RunReport() {

    this.createCookie("TokenInfo", sessionStorage.getItem("UserName"), 7);
    switch (this.ReportID.toString()) {
     
      case '1':
        if (this.Mainmodel.SubscriptionStatus != '-1') {
         
          if (this.Mainmodel.DateFrom == undefined && this.Mainmodel.BookindDate == undefined) {
            this.toastr.error('Please select a Start Date or Booking Date.'); //
          }
          else if (this.Mainmodel.DateFrom != undefined && this.Mainmodel.BookindDate != undefined) {
            this.toastr.error('You can select either Start Date or Booking Date at the time.');
          }
          else {
            var Datefrom = this.Mainmodel.DateFrom != undefined ?
              this.Mainmodel.DateFrom.jsdate.toString() : "";

              var DateTo = this.Mainmodel.BookindDate != undefined ?
              this.Mainmodel.BookindDate.jsdate.toString() : "";
            if (this.Mainmodel.DateFrom != undefined) {
              this.Mainmodel.BookingDateValue = "No";
              window.open(this.ApiBasePath + 'Reports/ReportGenerated.aspx?ReportID='
                + this.ReportID + '&OrganizationsRunDate='
                + this.Mainmodel.DateFrom.formatted
                + '&SubscriptionStatus='
                + this.Mainmodel.SubscriptionStatus
                + '&BookingDateValue='
                + this.Mainmodel.BookingDateValue);
            }
            else {
              this.Mainmodel.BookingDateValue = "Yes";
              window.open(this.ApiBasePath + 'Reports/ReportGenerated.aspx?ReportID='
                + this.ReportID + '&OrganizationsBookingRunDate='
                + this.Mainmodel.BookindDate.formatted
                + '&SubscriptionStatus='
                + this.Mainmodel.SubscriptionStatus
                + '&BookingDateValue='
                + this.Mainmodel.BookingDateValue);
            }
          }
        }
        else {
          this.toastr.error('Please select a Subscription Status')
        }
        break;

      case '3':
        if (this.Mainmodel.EntityStatus != '-1') {

          if (this.Mainmodel.DateFrom == undefined && this.Mainmodel.BookindDate == undefined) {
            this.toastr.error('Please select a Start Date or Booking Date.');
          }
          else if (this.Mainmodel.DateFrom != undefined && this.Mainmodel.BookindDate != undefined) {
            this.toastr.error('You can select either Start Date or Booking Date at the time.');
          }
          else {
            var Datefrom = this.Mainmodel.DateFrom != undefined ?
              this.Mainmodel.DateFrom.jsdate.toString() : "";

            var DateTo = this.Mainmodel.BookindDate != undefined ?
              this.Mainmodel.BookindDate.jsdate.toString() : "";

            var EnterPrise = this.Mainmodel.EnterPrise == true ? "Enterprise" : "";
            var Hotel = this.Mainmodel.Hotel == true ? "Hotel" : "";
            var NonHotel = this.Mainmodel.NonHotel == true ? "Non-Hotel" : "";
            this.Mainmodel.Bussinessaccount = EnterPrise + ',' + Hotel + ',' + NonHotel;
            if (this.Mainmodel.DateFrom != undefined) {
              this.Mainmodel.BookingDateValue = 'No';

              window.open(this.ApiBasePath + 'Reports/ReportGenerated.aspx?ReportID='
                + this.ReportID + '&EntityStatus='
                + this.Mainmodel.EntityStatus
                + '&startDate='
                + this.Mainmodel.DateFrom.formatted
                + '&Bussinessaccount='
                + this.Mainmodel.Bussinessaccount
                + '&BookingDateValue='
                + this.Mainmodel.BookingDateValue);
            }
            else {

              this.Mainmodel.BookingDateValue='Yes'
              window.open(this.ApiBasePath + 'Reports/ReportGenerated.aspx?ReportID='
                + this.ReportID
                + '&EntityStatus='
                + this.Mainmodel.EntityStatus
                + '&BookindDate='
                + this.Mainmodel.BookindDate.formatted
                + '&Bussinessaccount='
                + this.Mainmodel.Bussinessaccount
                + '&BookingDateValue='
                + this.Mainmodel.BookingDateValue);
            }

          }
        }
        else {
          this.toastr.error('Please select a Entity Status')
        }
        break;

      case '4':
        if (this.Mainmodel.MonthalySubStartDate == undefined && this.Mainmodel.BookindDate == undefined) {
          this.toastr.error('Please select a Start Date or Booking Date.');//
        }
        else if (this.Mainmodel.MonthalySubStartDate != undefined && this.Mainmodel.BookindDate != undefined) {
          this.toastr.error('You can select either Start Date or Booking Date at the time.');
        }
        else {
          var EnterPrise = this.Mainmodel.EnterPrise == true ? "1" : "";
          var Hotel = this.Mainmodel.Hotel == true ? "2" : "";
          var NonHotel = this.Mainmodel.NonHotel == true ? "3" : "";
          this.Mainmodel.Bussinessaccount = EnterPrise + ',' + Hotel + ',' + NonHotel;
          if (this.Mainmodel.MonthalySubStartDate != undefined) {
            this.Mainmodel.BookingDateValue = 'No';
            window.open(this.ApiBasePath + 'Reports/ReportGenerated.aspx?ReportID='
              + this.ReportID + '&Date='
              + this.Mainmodel.MonthalySubStartDate.formatted
              + '&Bussinessaccount='
              + this.Mainmodel.Bussinessaccount
              + '&BookingDateValue='
              + this.Mainmodel.BookingDateValue);
          } else {
            this.Mainmodel.BookingDateValue = 'Yes'

            window.open(this.ApiBasePath + 'Reports/ReportGenerated.aspx?ReportID='
              + this.ReportID
              + '&bookingDate='
              + this.Mainmodel.BookindDate.formatted
              + '&Bussinessaccount='
              + this.Mainmodel.Bussinessaccount
              + '&BookingDateValue='
              + this.Mainmodel.BookingDateValue);
          }
        }
        
        
        break;

      case '5':
        
        if (this.Mainmodel.DateFrom == undefined && this.Mainmodel.BookindDate == undefined) {
          this.toastr.error('Please select a Start Date or Booking Date.');
        }

        else if (this.Mainmodel.DateFrom != undefined && this.Mainmodel.BookindDate != undefined) {
            this.toastr.error('You can select either Start Date or Booking Date at the time.');
          }

        else {
         
          var Datefrom = this.Mainmodel.DateFrom != undefined ?
            this.Mainmodel.DateFrom.jsdate.toString() : "";

          var DateTo = this.Mainmodel.BookindDate != undefined ?
            this.Mainmodel.BookindDate.jsdate.toString() : "";
          if (this.Mainmodel.DateFrom != undefined) {
            this.Mainmodel.BookingDateValue = "No";
            window.open(this.ApiBasePath +
              'Reports/ReportGenerated.aspx?ReportID='
              + this.ReportID
              + '&OrganizationsRunDate='
              + this.Mainmodel.DateFrom.formatted
              + '&OrganizationStatus='
              + this.Mainmodel.OrganizationStatus
              + '&BookingDateValue='
              + this.Mainmodel.BookingDateValue);
          } else {
            this.Mainmodel.BookingDateValue = "Yes";

              window.open(this.ApiBasePath +
                'Reports/ReportGenerated.aspx?ReportID='
                + this.ReportID
                + '&OrganizationsBookdingDate='
                + this.Mainmodel.BookindDate.formatted
                + '&OrganizationStatus='
                + this.Mainmodel.OrganizationStatus
                + '&BookingDateValue='
                + this.Mainmodel.BookingDateValue);
          }
        } 
        
        break;

      case '6':
        
        if (!this.Mainmodel.IsRunByBookingDTEnable) {
          if (this.Mainmodel.DateFrom != undefined) {
            if (this.Mainmodel.DateTo != undefined) {
              var Datefrom = this.Mainmodel.DateFrom.jsdate;
              var DateTo = this.Mainmodel.DateTo.jsdate;

              if (Datefrom <= DateTo) {
                this.Mainmodel.BookingDateValue="No"
                window.open(this.ApiBasePath
                  + 'Reports/ReportGenerated.aspx?ReportID='
                  + this.ReportID
                  + '&DateFrom='
                  + this.Mainmodel.DateFrom.formatted
                  + '&DateTo='
                  + this.Mainmodel.DateTo.formatted
                  + '&BookingDateValue='
                  + this.Mainmodel.BookingDateValue);
              }
              else {
                this.toastr.error('Please select Starting date greater than or equal to Thru date.');
              }
            }
            else {
              this.toastr.error('Please select a Date.');
            }
          }
          else {
            this.toastr.error('Please select a Date.');
          }
        }
        else {
          if (this.Mainmodel.BookingFrom != undefined) {
            if (this.Mainmodel.BookingTo != undefined) {
              var Datefrom = this.Mainmodel.BookingFrom.jsdate;
              var DateTo = this.Mainmodel.BookingTo.jsdate;

              if (Datefrom <= DateTo) {
                this.Mainmodel.BookingDateValue = "Yes";
                window.open(this.ApiBasePath
                  + 'Reports/ReportGenerated.aspx?ReportID='
                  + this.ReportID
                  + '&BookingFrom='
                  + this.Mainmodel.BookingFrom.formatted
                  + '&BookingTo='
                  + this.Mainmodel.BookingTo.formatted
                  + '&IsBookingDateCheck='
                  + this.Mainmodel.IsRunByBookingDTEnable
                  + '&BookingDateValue='
                  + this.Mainmodel.BookingDateValue);
              }
              else {
                this.toastr.error('Please select From date greater than or equal to Thru date.');
              }
            }
            else {
              this.toastr.error('Please select a Thru date.');
            }
          }
          else {
            this.toastr.error('Please select a From date.');
          }
        }
          
        break;
      case '7':
    
        if (!this.Mainmodel.IsRunByBookingDTEnable) {
          if (this.Mainmodel.DateFrom != undefined || this.Mainmodel.DateTo != undefined) {

            if (this.Mainmodel.DateFrom != undefined) {
              if (this.Mainmodel.DateTo != undefined) {
                //if (this.Mainmodel.AccountExecutive != "-1") {
                var Datefrom = this.Mainmodel.DateFrom.jsdate;
                var DateTo = this.Mainmodel.DateTo.jsdate;
             
                if (Datefrom <= DateTo) {
                  this.Mainmodel.BookingDateValue = "No";
                  window.open(this.ApiBasePath + 'Reports/ReportGenerated.aspx?ReportID=' +
                    this.ReportID
                    + '&DateFrom='
                    + this.Mainmodel.DateFrom.formatted
                    + '&DateTo='
                    + this.Mainmodel.DateTo.formatted
                    + '&BookingDateValue='
                    + this.Mainmodel.BookingDateValue);
                }
                else {
                  this.toastr.error('Please select Starting date greater than or equal to Thru dates. ');
                }
              }
              //else {
              //   this.toastr.error('Please Select the Account Executive. ')
              // }
              //}
              else {
                this.toastr.error('Please enter the Thru date. ');
              }
            }
            else {
              this.toastr.error('Please enter the Starting date. ');
            }
          }
          else {
            this.toastr.error('Please enter the Starting and Thru date ');
          }
        }
        else {

          if (this.Mainmodel.BookingFrom != undefined || this.Mainmodel.BookingTo != undefined) {
            if (this.Mainmodel.BookingFrom != undefined) {
              if (this.Mainmodel.BookingTo != undefined) {
                //if (this.Mainmodel.AccountExecutive != "-1") {
                var Datefrom = this.Mainmodel.BookingFrom.jsdate;
                var DateTo = this.Mainmodel.BookingTo.jsdate;

                if (Datefrom <= DateTo) {
                  this.Mainmodel.BookingDateValue = "Yes";
                  window.open(this.ApiBasePath + 'Reports/ReportGenerated.aspx?ReportID=' +
                    this.ReportID
                    + '&BookingFrom='
                    + this.Mainmodel.BookingFrom.formatted
                    + '&BookingTo='
                    + this.Mainmodel.BookingTo.formatted
                    + '&IsBookingDateCheck='
                    + this.Mainmodel.IsRunByBookingDTEnable
                    + '&BookingDateValue='
                    + this.Mainmodel.BookingDateValue);
                }
                else {
                  this.toastr.error('Please select Booking start date greater than or equal to Booking Thru dates. ');
                }
              }
              //else {
              //   this.toastr.error('Please Select the Account Executive. ')
              // }
              //}
              else {
                this.toastr.error('Please enter the Booking Thru date. ');
              }
            }
            else {
              this.toastr.error('Please enter the Booking Start date. ');
            }
          }
          else {
            this.toastr.error('Please enter the Booking Start date and Booking Thru date ');
          }
        }

        
        break;
      case '8':

        var isValidate = true;
        if (this.Mainmodel.SubscriptionVersionStatus != 2) {

          
          if (this.Mainmodel.DateFrom == undefined) {
            this.toastr.error('Please enter the Starting date.');
            isValidate = false;
          }

          if (this.Mainmodel.DateTo == undefined) {
            this.toastr.error('Please enter the Thru date.');
            isValidate = false;
          }
          var Datefrom = this.Mainmodel.DateFrom.jsdate;
          var DateTo = this.Mainmodel.DateTo.jsdate;

          if (Datefrom > DateTo) {
            this.toastr.error('Please select Starting date greater than or equal to Thru date.');
            isValidate = false;
          }

          if (this.Mainmodel.EnterPrise != true && this.Mainmodel.Hotel != true && this.Mainmodel.NonHotel != true) {
            this.toastr.error('Please select the Business Accounts.');
            isValidate = false;
          }
        }

        if (this.Mainmodel.SubscriptionVersionStatus == 2) {
          this.Mainmodel.Hotel = true;
          if (this.Mainmodel.DateFrom == undefined) {
            this.toastr.error('Please enter the date.');
            isValidate = false;
          }
          else {
            this.Mainmodel.DateTo = this.Mainmodel.DateFrom;
          }
        }

        if (isValidate == true) {
          var EnterPrise = this.Mainmodel.EnterPrise == true ? "1" : "";
          var Hotel = this.Mainmodel.Hotel == true ? "2" : "";
          var NonHotel = this.Mainmodel.NonHotel == true ? "3" : "";
          var ZeroCostSubscription = this.Mainmodel.ZeroCostSubscription == true ? "4" : "";
          this.Mainmodel.Bussinessaccount = EnterPrise + ',' + Hotel + ',' + NonHotel + ',' + ZeroCostSubscription;
          window.open(this.ApiBasePath + 'Reports/ReportGenerated.aspx?ReportID=' +
            this.ReportID + '&DateFrom=' + this.Mainmodel.DateFrom.formatted + '&DateTo=' + this.Mainmodel.DateTo.formatted + '&Bussinessaccount=' +
            this.Mainmodel.Bussinessaccount + '&SubscriptionStatus=' + this.Mainmodel.SubscriptionVersionStatus);
        }
        break;
      case '9':
        window.open(this.ApiBasePath + 'Reports/ReportGenerated.aspx?ReportID=' +
          this.ReportID + '&Type=' + this.Mainmodel.Type);
        break;
      case '10':
        var isValidate = true;
         
        if (this._State == '' || this._State == "Select" || this._State == 'Select' || this._State == '-1' || this._State == undefined) {
          this.toastr.error('Please select the Billing Month.');
          isValidate = false;
        }
        if (isValidate == true) {
          window.open(this.ApiBasePath + 'Reports/ReportGenerated.aspx?ReportID=' +this.ReportID + '&TenantID=' + this._tenatidget + '&BillingMonth=' + this._State);
        }
        //this.toastr.error('Please enter the Thru date.' + this.ReportID + ' TENANTID:' + this._tenatidget + 'Date: ' + this._State);
        //this.ReportID + '&Type=' + this.Mainmodel.Type);
        break;
    }
  }
  /*-------End-----*/

  /*-------Functions for Cancel PlGroupingReport-----*/
  public ClosePLGroupingReport() {
    if (this.QueryPageName == "Reports") {
      this.router.navigate(['/Reports']);
    }

  }

  public SubscriptionVersion(value: string) {
    this.Mainmodel.ZeroCostSubscription = false;
    this.ShowZeroCostSubscription = false;
    if (value == "2") {
      this.ShowMonthly = true;
      this.BussinessAccount = true;
      this.Mainmodel.EnterPrise = true;
      this.Mainmodel.Hotel = true;
      this.Mainmodel.NonHotel = true;
      this.ShowZeroCostSubscription = true;
      this.Mainmodel.ZeroCostSubscription = true;
      this.DateRange = false;
      this.Mainmodel.DateFrom = null;
      this.Mainmodel.DateTo = null;
    }
    else {
      this.Mainmodel.DateFrom = null;
      this.Mainmodel.DateTo = null;
      this.ShowSubscription = false;
      this.ShowEntity = false;
      this.ShowSubscriptionStatus = true;
      this.ShowMonthly = false;
      this.BussinessAccount = true;
      this.Mainmodel.EnterPrise = true;
      this.Mainmodel.Hotel = true;
      this.Mainmodel.NonHotel = true;
      this.DateRange = true;
    }
  }

  /**Create Cookies****/

  createCookie(name: string, value: string, days: number) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  /*-------End-----*/
  public getalluser() {
    this._EntityService.GetAccExecutives(this.Mode,0,'0').subscribe(res => {
      this.AllAccExecutive = res;
    })

  }

  getCopyOfOptions(): IMyDpOptions {
    return JSON.parse(JSON.stringify(this.myDatePickerOptions));
  }

}



// WEBPACK FOOTER //
// ./src/app/Reports/PLReportGroupingComponent.ts